import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchNewVsRecurringCount = createAsyncThunk('fetchNewVsRecurringCount', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/reports/new-recurring?year=${obj.year}`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const newRecurringSlice = createSlice({
    name: 'newRecurringCount',
    initialState: {
        loading: false,
        newRecurringCount: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNewVsRecurringCount.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchNewVsRecurringCount.fulfilled, (state, action) => {
            state.loading = false;
            state.newRecurringCount = action.payload
        })
        builder.addCase(fetchNewVsRecurringCount.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default newRecurringSlice.reducer